module.exports = __webpack_public_path__ + "img/NymbleUp-Weekly Off.8a1c9b47.png";